import { render, staticRenderFns } from "./radio-button.component.vue?vue&type=template&id=55b596da&"
import script from "./radio-button.component.ts?vue&type=script&lang=ts&"
export * from "./radio-button.component.ts?vue&type=script&lang=ts&"
import style0 from "./radio-button.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports